type EmbedVideo = { provider: "youtube" | "vimeo"; id: string } | undefined;

export const getEmbedVideoId = (videoUrl: string): EmbedVideo => {
    const youtubeMatch = videoUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^&?/]+)/);
    if (youtubeMatch) {
        return { provider: "youtube", id: youtubeMatch[1] };
    }
    const vimeoMatch = videoUrl.match(/(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeoMatch) {
        return { provider: "vimeo", id: vimeoMatch[1] };
    }
    return undefined;
};

export const buildEmbedVideoUrl = (videoUrl: string): string => {
    const video = getEmbedVideoId(videoUrl);
    if (video?.provider === "youtube") {
        return `https://www.youtube.com/embed/${video.id}?autoplay=1&playsinline=0&rel=0`;
    }
    if (video?.provider === "vimeo") {
        return `https://player.vimeo.com/video/${video.id}?autoplay=1&dnt=1&playsinline=0`;
    }
    return videoUrl;
};
